import { SMOOTH_DROPDOWN_COMPONENTS_NAMES, SMOOTH_DROPDOWN_COMPONENT_NAMESPACE, } from '@che-ins-ui/header';
export default {
    SMOOTH_DROPDOWN_COMPONENTS_NAMES,
    SMOOTH_DROPDOWN_COMPONENT_NAMESPACE,
};
